import React from 'react';
import PropTypes from 'prop-types';
import {Box, Tooltip} from '@mui/material';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';

/**
 * Marks a row whose AI call is on the phone right now.
 *
 * The server decides what "right now" means — started, not reported finished, and inside the same
 * staleness window the dashboard's live-call count uses — so a call the dialer never closes out
 * stops showing here rather than staying lit forever.
 *
 * Rows are only re-fetched when the grid refreshes, so treat this as a snapshot taken at load.
 */
const AiCallInProgressRenderer = (props) => {
  if (!props.value) {
    return null;
  }

  return (
    <Tooltip title={'AI call in progress'} placement={'top'} arrow>
      <Box
        aria-label={'AI call in progress'}
        role={'img'}
        sx={{alignItems: 'center', display: 'flex', height: '100%'}}
      >
        <PhoneInTalkIcon sx={{color: '#2E7D32', fontSize: '1.15rem'}} />
      </Box>
    </Tooltip>
  );
};

AiCallInProgressRenderer.propTypes = {
  /** `aiCallInProgress` from the row; the icon renders only when true. */
  value: PropTypes.bool,
};

AiCallInProgressRenderer.defaultProps = {
  value: false,
};

export default AiCallInProgressRenderer;
